import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { UpdateCloudIntegrationInput } from '@cast/types-inventory';

import { getCloudAssetIntegrationsQueryKey } from 'hooks/queries/inventory/useCloudAssetIntegrationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type Payload = {
  id: string;
  payload: UpdateCloudIntegrationInput;
};

export const useUpdateCloudAssetIntegrationMutation = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: async ({ id, payload }: Payload) => {
      return apiClient.inventory.updateCloudAssetIntegration({
        organizationId: currentOrganization?.id ?? '',
        id,
        updateCloudAssetIntegrationInput: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getCloudAssetIntegrationsQueryKey(currentOrganization?.id),
      });
    },
    onError: (error: unknown) => {
      notify.error(`Update failed: ${parseApiError(error)}`);
    },
  });
};
